import { useSnackbarProgressStore } from '@aibees/shared/store';
import { forwardRef } from 'react';
import { ControlledProgressSnackbar } from './controlled-progress-snackbar';
import { TimerProgressSnackbar } from './timer-progress-snackbar';
import type { ProgressSnackbarProps as Props } from './types';

/**
 * Smart wrapper that chooses between ControlledProgressSnackbar and TimerProgressSnackbar
 * based on whether there's progress in the Zustand store for this snackbar ID.
 */
export const ProgressSnackbar = forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { id } = props;

    // Check if there's controlled progress in the store for this snackbar
    const hasControlledProgress = useSnackbarProgressStore((state) =>
      state.progress.has(id)
    );

    // Use controlled progress snackbar if progress exists in store, otherwise use timer
    if (hasControlledProgress) {
      return <ControlledProgressSnackbar ref={ref} {...props} />;
    }

    return <TimerProgressSnackbar ref={ref} {...props} />;
  }
);

ProgressSnackbar.displayName = 'ProgressSnackbar';
